import { LotSizeCalculator } from '@/components/LotSizeCalculator';
import { validateForm } from '@/helpers/form-validation';
import NiceSelect from 'nice-select2/dist/js/nice-select2';

new NiceSelect(document.querySelector('.js-lot-calc-pair'), {
  placeholder: 'Currency pair',
});
new NiceSelect(document.querySelector('.js-lot-calc-currency'), {
  placeholder: 'Account currency',
});
new NiceSelect(document.querySelector('.js-lot-calc-risk-tolerance'), {
  placeholder: 'Risk tolerance',
});

document
  .querySelector('.js-lot-calculator-form')
  .addEventListener('submit', (e) => {
    e.preventDefault();
    const lotSizeCalculator = new LotSizeCalculator();
    const valid = validateForm(e.target);
    if (valid) {
      lotSizeCalculator.calculate();
    } else {
      lotSizeCalculator.hideSpinning();
    }
  });
